import { present } from "./present";

export function assert<T>(obj: T, message?: string): asserts obj is Exclude<T, null | undefined | ''> {
  if (!present(obj)) {
    throw new Error(message || `Expected assertion to be truthy, was ${typeof obj} ${obj}`)
  }
}